import baseURL from '../common/axios';
class StockWOFileUploadServices {
    insertStockWOFile(dataModel) {
        return baseURL.httpMSInventoryUrl.post("StockWOFileUpload/Create", dataModel)
    }
    DeleteList(Id) {
        return baseURL.httpMSInventoryUrl.delete("StockWOFileUpload/DeleteList?id=" + Id)
    }
    getStockWOFileById(RefId) {
        return baseURL.httpMSInventoryUrl.get("StockWOFileUpload/Get?RefId=" + RefId + "")
    }

}
export default new StockWOFileUploadServices()